var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49967 2.33301C7.82185 2.33301 8.08301 2.59418 8.08301 2.91634V6.41634H11.583C11.9052 6.41634 12.1663 6.6775 12.1663 6.99967C12.1663 7.32185 11.9052 7.58301 11.583 7.58301H8.08301V11.083C8.08301 11.4052 7.82185 11.6663 7.49967 11.6663C7.1775 11.6663 6.91634 11.4052 6.91634 11.083V7.58301H3.41634C3.09418 7.58301 2.83301 7.32185 2.83301 6.99967C2.83301 6.6775 3.09418 6.41634 3.41634 6.41634H6.91634V2.91634C6.91634 2.59418 7.1775 2.33301 7.49967 2.33301Z",
    fill: "#00346B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.45d5726e8cd8c510a824e00a1e8e9ce1.svg";
export { ForwardRef as ReactComponent };